import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

export class SelectPlanningViewEvent extends AmplitudeEvent {
    constructor(props: { hasAccess: boolean }) {
        super("select_planning_view");
        this.props = props;
    }
}
export class SelectFocusViewEvent extends AmplitudeEvent {
    constructor() {
        super("select_focus_view");
    }
}
export class SelectExploreViewEvent extends AmplitudeEvent {
    constructor() {
        super("select_explore_view");
    }
}
